import { Routes } from "@angular/router";
import { AccountComponent } from "./components/account/account.component";
import { CalendarsComponent } from "./components/calendars/calendars.component";
import { CallbackComponent } from "./components/callback/callback.component";
import { DisclosureComponent } from "./components/disclosure/disclosure.component";
import { ErrorComponent } from "./components/error/error.component";
import { HomeComponent } from "./components/home/home.component";
import { KeyConceptsComponent } from "./components/key-concepts/key-concepts.component";
import { NotesComponent } from "./components/notes/notes.component";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { PrivacyComponent } from "./components/privacy/privacy.component";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";
import { SettingsComponent } from "./components/settings/settings.component";
import { SupportComponent } from "./components/support/support.component";
import { TasksComponent } from "./components/tasks/tasks.component";
import { TermsComponent } from "./components/terms/terms.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { ListsComponent } from "./components/lists/lists.component";
import { DeleteAccountComponent } from "./components/delete-account/delete-account.component";
import { adminAuthGuard, authGuard } from "./_helpers/auth.guard";
import { EventComponent } from "./components/event/event.component";
import { AdminComponent } from "./components/admin/admin.component";
import { PaymentComponent } from "./components/payment/payment.component";

export const routes: Routes = [
    { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    { path: 'callback', component: CallbackComponent, canActivate: [authGuard] },
    { path: 'settings', component: SettingsComponent, canActivate: [authGuard] },
    { path: 'notes', component: NotesComponent, canActivate: [authGuard] },
    { path: 'tasks', component: TasksComponent, canActivate: [authGuard] },
    { path: 'privacy', component: PrivacyComponent },
    { path: 'disclosure', component: DisclosureComponent },
    { path: 'terms', component: TermsComponent },
    { path: 'account', component: AccountComponent, canActivate: [authGuard] },
    { path: 'resetPassword', component: ResetPasswordComponent },
    { path: 'calendars', component: CalendarsComponent, canActivate: [authGuard] },
    { path: 'lists', component: ListsComponent, canActivate: [authGuard] },
    { path: 'event', component: EventComponent, canActivate: [authGuard] },
    { path: 'support', component: SupportComponent },
    { path: 'keyconcepts', component: KeyConceptsComponent },
    { path: 'error/:error', component: ErrorComponent },
    { path: 'home', component: HomeComponent },
    { path: 'dashboard', component: DashboardComponent, canActivate: [authGuard] },
    { path: 'admin', component: AdminComponent, canActivate: [adminAuthGuard] },
    { path: 'delete-account', component: DeleteAccountComponent },
    { path: 'payment/success', component: PaymentComponent, canActivate: [authGuard] },
    { path: 'payment/cancel', component: PaymentComponent, canActivate: [authGuard] },
    { path: '', component: PageNotFoundComponent },
    { path: '**', redirectTo: 'dashboard' }
];
